<template>
  <div>
    <AdminChatBar> T{{ $route.params.type.charAt(0).toUpperCase() }}P{{ $route.params.id }} Chat</AdminChatBar>
    <div class="page-content header-clear-small">
      <ul v-chat-scroll="{always: false, smooth: true}" class="messages">
        <div v-for="message in messages" :key="message.id" :class="generateClass( message )" class="message"
             role="alert">
          <h4 class="color-white">{{ message.message }}</h4>
          <strong class="alert-icon-text">{{ message.user.id == user.id ? "me" : message.user.name }}
            {{ timeFromDate(message.created_at) }}</strong>
          <span :class="generateClassAlert(message)"><i
              :class=" message.user.id == user.id ? 'fa fa-check font-18' : 'fa fa-inbox font-18'"></i></span>
        </div>
      </ul>
      <br>
      <br>
      <div class="row send-message color-theme">
        <div class="col-10">
          <div class="input-style has-icon input-style-1 input-required pb-1">
            <input v-model="message" v-on:keyup.enter="sendMessage" placeholder="Type your message" type="text">
          </div>
        </div>
        <div class="col-2">
          <span @click="sendMessage" :disabled="!message.length" class="alert-icon"><i class="fa fa-paper-plane font-18"></i></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import global from "@/mixins/global";
import axios from "axios";
// import ChatAppBar from "@/components/ChatAppBar";
import {mapMutations} from "vuex"
import AdminChatBar from "@/components/admin/AdminChatBar";

export default {
  components: {AdminChatBar},
  mixins: [global],
  name: "AdminChat",
  data() {
    return {
    }
  },
  mounted() {
    this.updateMessages([])
    this.fetchMessages()
    setInterval(this.fetchMessages, 1200000)
  },
  methods: {
    ...mapMutations(["updateMessages"]),
    sendMessage() {
      let data = {
        "message": this.message
      }
      if (this.$route.params.type === "stand") {
        data.stand_id = this.$route.params.id
      } else if (this.$route.params.type === "investment") {
        data.investment_id = this.$route.params.id
      } else if (this.$route.params.type === "round") {
        data.round_id = this.$route.params.id
      } else {
        data.farming_id = this.$route.params.id
      }
      axios.post(this.base_url + this.$route.params.type +"s" + "/messages", data, this.requestAuthHeaderToken(localStorage.getItem("token"))).then(() => {
        this.message = ""
        this.fetchMessages()
        this.scrollMessages()
      })
    },
    fetchMessages(){
      axios.get(this.base_url+this.$route.params.type+"s"+"/messages/"+this.$route.params.id,
          this.requestAuthHeaderToken(localStorage.getItem("token"))).then(
          response=>{
            // this.messages = response
            this.updateMessages(response.data.data.reverse())
          }).catch(error=>{this.error = error})
    },
  },
  computed: {
    stateuser(){
      return this.$store.getters.user
    },
    messages(){
      return this.$store.getters.messages
    }
  }
}
</script>

<style scoped>
.message-sent{
  margin: 10px 15px 10px 30px;
}
.message-received{
  margin: 10px 30px 10px 15px;
}

.alert-sent{
  left: -1px;
}

.alert-received{
  right: -1px;
}

.fa-paper-plane{
  padding: 15px 20px 15px 1px;
}

.send-message{
  position: fixed;
  bottom: 18px;
  background-color: #127502;
  left: 0;
  right: 0;
  min-height: 60px;
}
</style>